import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-shared-top-menu',
  templateUrl: './shared-top-menu.component.html',
  styleUrls: ['./shared-top-menu.component.css']
})
export class SharedTopMenuComponent implements OnInit {

  project_id;

	@Input() lead_id:any;
	@Input() lead_status:any;
	@Input() overview_tab:any;
	@Input() activity_log_tab:any;
	@Input() basic_info_tab:any;
	@Input() detailed_info_tab:any;
	@Input() boq_tab:any;
	@Input() ppt_tab:any;
	@Input() files_tab:any;
	@Input() calender_tab:any;
	@Input() proposal_tab:any;
	@Input() custom_tab:any;
  @Input() payments_tab:any;
	@Input() lead_details:any = {};

  constructor() { }

  ngOnInit() {
    this.project_id = this.lead_details.project_details.id;
  }

  isProjectInWip():boolean {
    this.project_id = this.lead_details.project_details.id;
    var wip_array = ["wip", "pre_10_percent", "10_50_percent", "50_percent", "installation", "on_hold", "inactive"]
    if(this.lead_details && this.lead_details.project_details && this.lead_details.project_details.status && wip_array.includes(this.lead_details.project_details.status)){
      return true
    }
    else{
      return false
    }
  }

}



// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/platform/lead/shared-top-menu/shared-top-menu.component.ts